import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { useCheckPermission } from 'src/utils/checkPermission';

export interface TopBlockPropsType {
    newRoute: boolean;
    disableEdit: boolean;
    handleSave: () => void;
    handleDelete?: () => void;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    const canDelete = useCheckPermission('EGON_ROUTE.DELETE');

    return (
        <BodyTopBlock
            actions={[
                {
                    label: translate(props.newRoute ? 'egonRouteDetail.create' : 'egonRouteDetail.save'),
                    onClick: () => props.handleSave(),
                    hidden: props.disableEdit,
                    'data-testid': 'egon-route-save',
                },
                {
                    label: translate('egonRouteDetail.delete'),
                    onClick: () => props.handleDelete && props.handleDelete(),
                    hidden: props.newRoute || !canDelete,
                    variant: 'outlined',
                    'data-testid': 'egon-route-delete',
                },
            ]}
        />
    );
};

export default TopBlock;
